export const PaymentStatus = {
  PAYMENT_INITIATED: "PAYMENT_INITIATED",
  PAYMENT_COMPLETED: "PAYMENT_COMPLETED",
  REFUND_UNDER_PROCESS: "REFUND_UNDER_PROCESS",
  REFUND_COMPLETED: "REFUND_COMPLETED",
  PAYMENT_FAILED: "PAYMENT_FAILED",
};
